import { QueryClient } from '@tanstack/react-query';

// Singleton shared by main.tsx (provider) and the auth store, which clears it
// on login/logout so cached data never leaks between sessions (e.g. mock
// test-user data lingering after switching to a real SSO session).
export const queryClient = new QueryClient({
	defaultOptions: {
		queries: {
			staleTime: 1000 * 60 * 5, // 5 minutes
			retry: 1
		}
	}
});
